import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import styled from "@emotion/styled";
import classNames from "classnames";
const StyledStack = styled.div(props => {
    var _a;
    return ({
        display: (_a = props.display) !== null && _a !== void 0 ? _a : "flex",
        alignItems: props.alignItems,
        alignContent: props.alignContent,
        justifyContent: props.justifyContent,
        gap: props.gap,
        width: props.width,
        height: props.height,
        minWidth: props.minWidth,
        maxWidth: props.maxWidth,
        minHeight: props.minHeight,
        maxHeight: props.maxHeight,
        flexWrap: props.flexWrap,
        flexDirection: props.flexDirection,
        margin: props.margin,
        padding: props.padding,
        borderRadius: props.borderRadius,
        border: props.border,
        backgroundColor: props.backgroundColor,
        overflow: props.overflow,
    });
});
export const GrStack = ({ children, className, ...props }) => {
    return (_jsx(StyledStack, { className: classNames("GrStack", className), ...props, children: children }));
};
//# sourceMappingURL=GrStack.js.map